import { getListFeatureMerchant, updateFeatureStatusMerchant, updateFeatureStatusMerchantBulk } from '../../utils/api';
import { ACTION, FAILED, LOADING, RESET, RESET_ALL, SUCCESS } from './constants';

export function fetchUpdateFeatureStatusMerchant(payload, callback) {
  return async (dispatch) => {
    // const state = getState();
    const KEY = 'UpdateStatus';
    try {
      dispatch(loadingAction(true, KEY));
      const { data } = await updateFeatureStatusMerchant(payload);
      dispatch(successAction(data, KEY));
      callback({
        success: true
      });
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
      callback({
        success: false,
        message: error.message
      });
    }
  };
}

export function fetchListFeatureMerchant() {
  return async (dispatch) => {
    // const state = getState();
    const KEY = 'ListFeatureMerchant';
    try {
      dispatch(loadingAction(true, KEY));
      const { data } = await getListFeatureMerchant();
      dispatch(successAction(data, KEY));
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
    }
  };
}

export function fetchUpdateFeatureStatusMerchantBulk(payload, callback = () => {}) {
  return async (dispatch) => {
    // const state = getState();
    const KEY = 'UpdateStatusBulk';
    try {
      dispatch(loadingAction(true, KEY));
      const { data } = await updateFeatureStatusMerchantBulk(payload);
      dispatch(successAction(data, KEY));
      callback({
        success: true
      });
    } catch (error) {
      dispatch(failedAction(error.message, KEY));
      callback({
        success: false,
        message: error.message,
        status: error.status
      });
    }
  };
}


export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key, message) {
  return { type: SUCCESS, data, key, message: message };
}

export function setAction(data) {
  return { type: ACTION, data };
}
export function reset(key) {
  return { type: RESET, key };
}
export const clearRedux = (key)  => {
  return async(dispatch) => {
    dispatch(reset(key));
  };
};

export function resetAll() {
  return { type: RESET_ALL };
}
export const clearAllRedux = ()  => {
  return async(dispatch) => {
    dispatch(resetAll());
  };
};
